import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Socket } from 'ng-socket-io';

@Injectable()
export class SocketProvider {

  constructor(
    public http: HttpClient,
    private socket: Socket
  ) {

    this.connect();
  }
  
  async connect(){
    const a = this.socket.connect();
    setTimeout(() => {
      
    }, 4000);
    return a;
  }

  getSocket(){
    return this.socket;
  }

  adicionaTopico(topico){
    this.socket.on(topico, function(x){
      console.log();
    });
  }

  removeTopico(topico){
    this.socket.removeListener(topico);
  }

  removeAll(){
    this.socket.removeAllListeners();
  }

}



// WEBPACK FOOTER //
// ./src/providers/socket/socket.ts